import React from "react";
import Table from "../../core/Table";
import { labels } from "../../../localization/labels";
import { constants } from "../../../utils/Constants";

const KnowledgeManagement = ({
  data,
  columns,
  paginationOptions,
  selectRow,
  onTableChange,
  onRowClick,
  cellEditProps,
  node,
  handleCreate,
  onActiveButtonChange,
  handleAdvancedSearchShow,
  advancedSearchParams,
  pageInfo,
  sortInfo,
  contextMenuItems,
  deleteAdvancedSearchParams
}) => {
  return (
    <div className="container">
      <div className="tabVerticalSize" />
      <div className="distance-from-tab">
        <Table
          node={node}
          data={data}
          columns={columns}
          paginationOptions={paginationOptions}
          selectRow={selectRow}
          onTableChange={onTableChange}
          onRowClick={onRowClick}
          cellEditProps={cellEditProps}
          tableLabel={labels.knowledgeManagement}
          onCreateRow={handleCreate}
          onActiveButtonChange={onActiveButtonChange}
          handleAdvancedSearchShow={handleAdvancedSearchShow}
          advancedSearchParams={advancedSearchParams}
          createRowProcesses={[constants.OPERATION_CREATE]}
          changeActiveProcesses={[constants.OPERATION_DELETE]}
          pageInfo={pageInfo}
          sortInfo={sortInfo}
          showTableHeader
          contextMenuItems={contextMenuItems}
          deleteAdvancedSearchParams={deleteAdvancedSearchParams}
        />
      </div>
    </div>
  );
};

export default KnowledgeManagement;
